import Vue from 'vue';
import Router from 'vue-router';
// 首页
import index from '@/pages/index/index.vue';
// 首页
import hssp  from '@/pages/hssp/index.vue';
// 新闻资讯
import xwzx from '@/pages/xwzx/index.vue';
// 新闻资讯-更多
import xwzxMore from '@/pages/xwzx/more/index.vue';
// 诉讼服务
import ssfw from '@/pages/ssfw/index.vue';
// 诉讼服务-更多
import ssfwMore from '@/pages/ssfw/more/index.vue';
// 审执数据
import szsj from '@/pages/szsj/index.vue';
// 法院介绍
import fyjs from '@/pages/fyjs/index.vue';
// 法院介绍 - 法官介绍更多
import fgjsMore from '@/pages/fyjs/fgjsMore/index.vue';
// 扣押拍卖
import kypm from '@/pages/kypm/index.vue';
// 扣押拍卖-更多
import kypmMore from '@/pages/kypm/more/index.vue';
// 扣押拍卖-详情
import kypmXq from '@/pages/kypm/xq/index.vue';
// 扣押拍卖-扣押详情
import kypmKyxq from '@/pages/kypm/kyxq/index.vue';
// 海事案例
import hsal from '@/pages/hsal/index.vue';
// 海事案例-更多
import hsalMore from '@/pages/hsal/more/index.vue';
// 海事案例-详情
import hsalXq from '@/pages/hsal/xq/index.vue';
// 理论探讨
import lltt from '@/pages/lltt/index.vue';
// 理论探讨-更多
import llttMore from '@/pages/lltt/more/index.vue';
// 理论探讨-更多
import llttDetail from '@/pages/lltt/detail/index.vue';
// 审判通报
import sptb from '@/pages/sptb/index.vue';
// 审判通报-更多
import sptbMore from '@/pages/sptb/more/index.vue';
// 法律资源
import flzy from '@/pages/flzy/index.vue';
// 法律资源-更多
import sfwjMore from '@/pages/flzy/more/index.vue';
// 域外司法
import ywsf from '@/pages/ywsf/index.vue';
// 域外司法-更多
import ywsfMore from '@/pages/ywsf/more/index.vue';
// 海事仲裁
import hszc from '@/pages/hszc/index.vue';
// 海事仲裁-更多
import hszcMore from '@/pages/hszc/more/index.vue';
// 专题
import zt from '@/pages/zt/index.vue';
// 庭审直播公开
import tszbgk from '@/pages/tszbgk/index.vue';
// 专题-详情
import ztDetail from '@/pages/zt/detail/index.vue';
// 专题-详情-中国40周年
import ztDetail1 from '@/pages/zt/detail1/index.vue';

// 专题-详情-中国40周年
import hssp40 from '@/pages/zt/hssp40/index.vue';

// 专题文章详情
import ztXq from '@/pages/zt/xq/index.vue';
// 专题文章详情
import ztXqhssp from '@/pages/zt/xqhssp/index.vue';
// 专题-更多
import ztMore from '@/pages/zt/more/index.vue';
// 专题-更多
import ztMorehssp from '@/pages/zt/morehssp/index.vue';
// 裁判文书公开
import cpwsgk from '@/pages/cpwsgk/index.vue';
// 裁判文书公开详情
import cpwsgkDetail from '@/pages/cpwsgk/detail/index.vue';
// 详情页面
import detail from '@/pages/detail/index.vue';

// 搜索结果页面
import search from '@/pages/search/index.vue';
// 新闻资讯详情页面
import xwzxDetail from '@/pages/detail/xwzx/index.vue';

// 视频播放页面
import spbf from '@/pages/detail/spbf/index.vue';
// 学习新时代列表页
import xxxsd from '@/pages/xxxsd/index.vue';

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err);
};
// 使用路由
Vue.use(Router);
// 导出路由模块
export default new Router({
    routes: [
        {
            path: '/',
            redirect: '/index'
        },

        // 首页
        {
            path: '/index',
            name: 'index',
            component: index
        },
        // 首页
        {
            path: '/hssp',
            name: 'hssp',
            component: hssp
        },

        // 学习新时代列表
        {
            path: '/xxxsd',
            name: 'xxxsd',
            component: xxxsd
        },
        // 搜索结果页面
        {
            path: '/search',
            name: 'search',
            component: search
        },
        // 新闻资讯
        {
            path: '/xwzx',
            name: 'xwzx',
            component: xwzx
        },
        // 新闻资讯-更多
        {
            path: '/xwzx/more',
            name: 'xwzxMore',
            component: xwzxMore
        },
        // 海事诉讼
        {
            path: '/ssfw',
            name: 'ssfw',
            component: ssfw
        },
        // 海事诉讼-更多
        {
            path: '/ssfw/more',
            name: 'ssfwMore',
            component: ssfwMore
        },
        // 审执数据
        {
            path: '/szsj',
            name: 'szsj',
            component: szsj
        },
        // 法院介绍
        {
            path: '/fyjs',
            name: 'fyjs',
            component: fyjs
        },
        // 法院介绍 - 法官介绍更多
        {
            path: '/fyjs/fgjsMore',
            name: 'fgjsMore',
            component: fgjsMore
        },
        // 扣押拍卖
        {
            path: '/kypm',
            name: 'kypm',
            component: kypm
        },
        // 扣押拍卖-更多
        {
            path: '/kypm/more',
            name: 'kypmMore',
            component: kypmMore
        },
        // 扣押拍卖-详情
        {
            path: '/kypm/xq',
            name: 'kypmXq',
            component: kypmXq
        },
        // 扣押拍卖-详情
        {
            path: '/kypm/kyxq',
            name: 'kypmKyxq',
            component: kypmKyxq
        },
        // 海事案例
        {
            path: '/hsal',
            name: 'hsal',
            component: hsal
        },
        // 海事案例-更多
        {
            path: '/hsal/more',
            name: 'hsalMore',
            component: hsalMore
        },
        // 海事案例-详情
        {
            path: '/hsal/xq',
            name: 'hsalXq',
            component: hsalXq
        },
        // 理论探讨
        {
            path: '/lltt',
            name: 'lltt',
            component: lltt
        },
        // 理论探讨-更多
        {
            path: '/lltt/more',
            name: 'llttMore',
            component: llttMore
        },
        // 理论探讨-更多
        {
            path: '/lltt/dedail',
            name: 'llttDetail',
            component: llttDetail
        },
        // 审判通报
        {
            path: '/sptb',
            name: 'sptb',
            component: sptb
        },
        // 审判通报-更多
        {
            path: '/sptb/more',
            name: 'sptbMore',
            component: sptbMore
        },
        // 法律资源
        {
            path: '/flzy',
            name: 'flzy',
            component: flzy
        },
        // 法律资源-更多
        {
            path: '/flzy/more',
            name: 'sfwjMore',
            component: sfwjMore
        },
        // 域外司法
        {
            path: '/ywsf',
            name: 'ywsf',
            component: ywsf
        },
        // 域外司法-更多
        {
            path: '/ywsf/more',
            name: 'ywsfMore',
            component: ywsfMore
        },
        // 海事仲裁
        {
            path: '/hszc',
            name: 'hszc',
            component: hszc
        },
        // 海事仲裁-更多
        {
            path: '/hszc/more',
            name: 'hszcMore',
            component: hszcMore
        },
        // 专题
        {
            path: '/zt',
            name: 'zt',
            component: zt
        },


        // 庭审直播公开
        {
            path: '/tszbgk',
            name: 'tszbgk',
            component: tszbgk,
            meta:{active:'index'}
        },
        // 裁判文书公开
        {
            path: '/cpwsgk',
            name: 'cpwsgk',
            component: cpwsgk,
            meta:{active:'index'}
        },
        // 裁判文书公开
        {
            path: '/cpwsgk/detail',
            name: 'cpwsgkDetail',
            component: cpwsgkDetail,
            meta:{active:'index'}
        },
        // 专题-详情
        {
            path: '/zt/detail',
            name: 'ztDetail',
            component: ztDetail
        },
        // 专题-详情
        {
            path: '/zt/detail1',
            name: 'ztDetail1',
            component: ztDetail1
        },
        // 专题-海事审判40周年
        {
            path: '/zt/hssp40',
            name: 'hssp40',
            component: hssp40
        },
        // 专题-更多
        {
            path: '/zt/more',
            name: 'ztMore',
            component: ztMore
        },
        // 专题-更多
        {
            path: '/zt/morehssp',
            name: 'ztMorehssp',
            component: ztMorehssp
        },
        // 专题中的文章详情
        {
            path: '/zt/xq',
            name: 'ztXq',
            component: ztXq
        },
        // 专题中的文章详情
        {
            path: '/zt/xqhssp',
            name: 'ztXqhssp',
            component: ztXqhssp
        },

        // 详情页面
        {
            path:'/detail',
            name:'detail',
            component: detail
        },
        // 新闻资讯详情页面
        {
            path:'/xwzxDetail',
            name:'xwzxDetail',
            component: xwzxDetail
        },
        // 视频播放页面
        {
            path:'/spbf',
            name:'spbf',
            component: spbf
        }
    ]
});
